import { useQuery } from '@apollo/client';

import Article from '@components/Article';
import styles from '@components/Article.module.css';
import BackButton from '@components/buttons/BackButton';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import { GetArticleDocument, GetArticleQuery, GetArticleQueryVariables } from '@typing/Generated';

type Props = {
  articleId: string;
  journeyId: string;
};

const ExpertJourneyArticlePage = ({ articleId, journeyId }: Props) => {
  const getArticleQuery = useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, {
    variables: {
      id: articleId
    }
  });

  return (
    <HandleQuery query={getArticleQuery}>
      {data => (
        <ExpertJourneyPage helmetKey="pageTitles.expertJourney.article.show" journeyId={journeyId}>
          <div>
            <div className={styles.clientHeader}>
              <BackButton />
              <div className={styles.articleToolbar} />
            </div>
            <Article article={data.article} journeyId={journeyId} refetch={getArticleQuery.refetch} />
          </div>
        </ExpertJourneyPage>
      )}
    </HandleQuery>
  );
};

export default ExpertJourneyArticlePage;
